import { Reveal, Chapter } from "./Reveal";
import { CreditCard, Ship, ClipboardList, Package } from "lucide-react";
import { useT } from "../i18n";

const ICONS = [CreditCard, Ship, ClipboardList, Package];

const TradeTerms = () => {
  const t = useT();
  return (
    <section id="terms" data-testid="trade-terms-section" className="border-y border-gold/10 bg-[#0B132B] py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number="02" label={t.terms.label} testid="terms-chapter" />
        </Reveal>
        <div className="mt-8 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <Reveal delay={0.1}>
            <h2 className="font-display text-3xl font-semibold uppercase leading-tight tracking-wide text-white sm:text-4xl">
              {t.terms.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="font-display text-lg italic text-gold md:text-xl">{t.terms.sub}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px bg-slate-800/60 sm:grid-cols-2 lg:grid-cols-4">
          {t.terms.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.t} delay={0.07 * i}>
                <div
                  data-testid={`trade-term-${i + 1}`}
                  className="group flex h-full flex-col bg-[#0B132B] p-8 transition-[background-color] duration-500 hover:bg-[#111D38]"
                >
                  <Icon size={26} strokeWidth={1.5} className="text-gold transition-transform duration-500 group-hover:-translate-y-1" />
                  <h3 className="mt-6 font-mono text-xs uppercase tracking-[0.22em] text-slate-300">{item.t}</h3>
                  <p className="mt-3 font-display text-lg font-medium text-white">{item.v}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.3}>
          <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-slate-400">{t.terms.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default TradeTerms;
